import React, { useState } from "react";
import { Link } from "react-router-dom";
import CONSTANT from "../../../constant";
import Header from "../../../component/common/Header";
import { TextField } from "@fluentui/react/lib/TextField";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { confirmReceived } from "../../../actions/DakManagement";
import { toast } from "react-toastify";
import { getCookie } from "../../../utils";

function DakManagement(props) {
  const { details } = props;
  const initialValues = {
    awb: details.awb,
  };

  const [values, setValues] = useState(initialValues);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const user = getCookie(CONSTANT.cookie.userDetail);

  function onUserInput(field, value) {
    setShowErrorAlert(false);
    values[field] = value;
    setValues({ ...values });
  }

  async function onSubmit() {
    setShowLoader(true);
    try {
      const { id } = details;
      await confirmReceived(id);
      toast("Dak Updated");
      props.history.goBack();
    } catch (e) {
      console.log(e, "eee");
    }
    setShowLoader(false);
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-2 px-0">
          <Header />
        </div>
        <div className="col-md-10 mt-3">
          {showLoader ? (
            <p>Please wait...</p>
          ) : (
            <>
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <h1 className="page-title">DAK Update</h1>
                <Link
                  to={CONSTANT.component.dakManagementList.url}
                  className="btn btn-sm submit-button p-2"
                >
                  <i className="fa fa-list mr-2" />
                  Dak list
                </Link>
              </div>
              <div className="col-md-12" style={{ border: "1p solid red" }}>
                <form onSubmit={(e) => e.preventDefault()}>
                  <div className="mt-3">
                    <p>
                      From:{" "}
                      <span style={{ fontWeight: "bold" }}>{details.name}</span>
                    </p>
                  </div>
                  <div className="mt-3">
                    <p>
                      To:{" "}
                      <span style={{ fontWeight: "bold" }}>{details.to}</span>
                    </p>
                  </div>
                  <div className="mt-3">
                    <p>Description:</p>
                    <p style={{ fontWeight: "bold" }}>{details.description}</p>
                  </div>
                  {user.designationCode === 370 ? (
                    <div className="mt-3">
                      <TextField
                        label="AWB"
                        required
                        onChange={(e) => onUserInput("awb", e.target.value)}
                        value={values.awb}
                      />
                    </div>
                  ) : null}
                  <div className="col-md-12 mt-3">
                    {showErrorAlert && (
                      <MessageBar
                        delayedRender={false}
                        messageBarType={MessageBarType.error}
                      >
                        Please fill all fields
                      </MessageBar>
                    )}
                  </div>
                  <div
                    className="mt-3"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <PrimaryButton text="Confirm Received" onClick={onSubmit} />
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default DakManagement;
